/* eslint-disable max-len */
import Logo from '../../../../assets/governance.png';
import {API_ENDPOINT_JSON} from '../../../../config';

import {
  antiCompetitiveBehaviorTabQuestions,
  antiCorruptionTabQuestions,
  economicPerformanceTabQuestions,
  indirectEconomicImpactsTabQuestions,
  marketingAndLabelingTabQuestions,
  procurementPracticesTabQuestions,
  publicPolicyTabQuestions,
  taxTabQuestions
} from './governanceTabs';

export const governance = {
  header: {
    imageUrl: Logo,
    title: 'Governance',
    description: `Focuses on a company's internal controls, leadership structures, transparency, 
and ethical standards in decision-making and accountability.`,
    noOfModules: 8,
    answeredQuestions: 16,
    totalQuestions: 65
  },
  APIRoute: API_ENDPOINT_JSON.ESG.GRI.governance,
  tabs: [
    {
      id: 'publicPolicy',
      title: 'Public Policy',
      questions: publicPolicyTabQuestions
    },
    {
      id: 'marketingAndLabeling',
      title: 'Marketing and Labeling',
      questions: marketingAndLabelingTabQuestions
    },
    {
      id: 'economicPerformance',
      title: 'Economic Performance',
      questions: economicPerformanceTabQuestions
    },
    {
      id: 'indirectEconomicImpacts',
      title: 'Indirect Economic Impacts',
      questions: indirectEconomicImpactsTabQuestions
    },
    {
      id: 'procurementPractices',
      title: 'Procurement Practices',
      questions: procurementPracticesTabQuestions
    },
    {
      id: 'antiCorruption',
      title: 'Anti-corruption',
      questions: antiCorruptionTabQuestions
    },
    {
      id: 'antiCompetitiveBehavior',
      title: 'Anti-competitive Behavior',
      questions: antiCompetitiveBehaviorTabQuestions
    },
    {
      id: 'tax',
      title: 'Tax',
      questions: taxTabQuestions
    }
  ]
};
